import Api from '@/api/Api'
import store from '../store'

export default {
  // PaySlip
  async getPaySlipList (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('payroll/payslips', { params }))
  },

  async getPaySlipSingle (id = '') {
    return store.dispatch('checkResponseApi', await Api().get(`payroll/payslips/${id}`))
  },

  async getPaySlipLatestCode () {
    return store.dispatch('checkResponseApi', await Api().get('payroll/payslips/latest-code'))
  },

  async createPaySlip (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('payroll/payslips', data, options))
  },

  async updatePaySlip (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`payroll/payslips/${id}`, data, options))
  },

  async updatePaySlipStatus (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`payroll/payslips/${id}/status`, data, options))
  },

  async deletePaySlip (id = '') {
    return store.dispatch('checkResponseApi', await Api().delete(`payroll/payslips/${id}`))
  },

  // Employee Group
  async getEmployeeGroupList (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('payroll/employee-groups', { params }))
  },

  async getEmployeeGroupSingle (id = '') {
    return store.dispatch('checkResponseApi', await Api().get(`payroll/employee-groups/${id}`))
  },

  async createEmployeeGroup (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('payroll/employee-groups', data, options))
  },

  async updateEmployeeGroup (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`payroll/employee-groups/${id}`, data, options))
  },

  async updateEmployeeGroupAssign (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`payroll/employee-groups/${id}/assign-employees`, data, options))
  },

  async deleteEmployeeGroup (id = '') {
    return store.dispatch('checkResponseApi', await Api().delete(`payroll/employee-groups/${id}`))
  },

  // Condition
  async getConditionList (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('payroll/conditions', { params }))
  },

  async getConditionSingle (id = '') {
    return store.dispatch('checkResponseApi', await Api().get(`payroll/conditions/${id}`))
  },

  async createCondition (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('payroll/conditions', data, options))
  },

  async updateCondition (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`payroll/conditions/${id}`, data, options))
  },

  async deleteCondition (id = '') {
    return store.dispatch('checkResponseApi', await Api().delete(`payroll/conditions/${id}`))
  },
}



// WEBPACK FOOTER //
// ./src/api/PayrollService.js